import {
  emptyPrimaryContact,
  PrimaryContact,
} from "../../../shared/model/primary-contact";
import { emptyPatientEncounter, PatientEncounter } from "./patient-encounter";

export interface PatientViewModel {
    patientId: number;
    contact: PrimaryContact;
    patientMasterId: number;
    patientStatus: string;
    patientStatusDt: string;
    patientEncounterId: number;
    clientId?: string;
    advisorPatientId?: number;
    workflowSubStatus?: {
        subStatusName: string;
    };
    patientEncounters: PatientEncounter[];
    userId?: number
}

interface BaseAPIRequiredContactInfo {
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  brithDate?: string | null | undefined;
}

export interface BaseAPIRequiredPatient {
  patientId: number;
  contact: BaseAPIRequiredContactInfo;
  userId?: number
}

export const emptyPatientViewModel: PatientViewModel = {
  patientId: 0,
  contact: emptyPrimaryContact,
  patientMasterId: 0,
  patientStatus: "",
  patientStatusDt: "",
  patientEncounterId: 0,
  clientId: "",
  workflowSubStatus: {
    subStatusName: "",
  },
  patientEncounters: [emptyPatientEncounter],
};

export interface PatientCurrentInsurance {
  patientCurrentInsuranceId: number
  patientId: number
  payorId: number
  payorPlanId: number
  subscriberName: string
  subscriberRelation: number
  memberId: string
  groupNumber: string
}

export const emptyPatientCurrentInsurance: PatientCurrentInsurance = {
  patientCurrentInsuranceId: 0,
  patientId: 0,
  payorId: 0,
  payorPlanId: 0,
  subscriberName: "",
  subscriberRelation: 9,    //Self
  memberId: "",
  groupNumber: ""
}

export interface PatientWaiver {
  waiverId: number
  patientId: number
  scholarshipPercentage: number
  scholarshipAmount: number
  fplRatio: number
  expenseIncomeRatio: number
  expirationDt: string
  monthlyExpenses: number
  householdSize: number
  educationLevel: number
}

export const emptyPatientWaiver: PatientWaiver = {
  waiverId: 0,
  patientId: 0,
  scholarshipPercentage: 0,
  scholarshipAmount: 0,
  fplRatio: 0,
  expenseIncomeRatio: 0,
  expirationDt: "",
  monthlyExpenses: 0,
  householdSize: 0,
  educationLevel: 0
}
